module.exports = __webpack_public_path__ + "static/iganari_-68308795d5990681c949732a60b95c9e.jpg";